<template>
  <div>
    <button @click="convertAndDownload">
      <span>Télécharger csv de mise à jour</span>
    </button>
  </div>
</template>

<script>
import { getMailingData, convertToCSV } from '@/mailingDataHelper'
export default {
  props: {
    jsonData: {
      type: Array,
      required: true
    }
  },
  methods: {
    convertAndDownload() {
      const { errors, data } = getMailingData(this.jsonData)
      if (errors.length) {
        const response = window.confirm(
          `Il y a des erreurs dans les données: \n${errors
            .map(e => e.message)
            .join('\n')}
          Voulez-vous télécharger les données valides?`
        )
        if (!response) {
          return
        }
      }
      const csvData = convertToCSV(data)
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const datetime = new Date().toISOString().slice(0, 16)
      link.setAttribute('download', `formulaires_${datetime}.csv`)
      link.setAttribute('href', URL.createObjectURL(blob))
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
button {
  background-color: lightgoldenrodyellow;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  span {
    font-size: 16px;
    font-weight: bolder;
  }
}
</style>
